import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BllinkUtils from '../../../components/common/utils/utils';
import { isAdminSelector } from '../../../components/store/auth/selectors';
import { showLoader, hideLoader } from '../../../components/store/common/slice';
import { verifyLoggedIn } from '../../../components/store/auth/actions';
import Table from '../../../components/common/table/TableFunctional';
import { constants } from '../../../components/common/constants/constants';
import { calcMonthsTextForSelectBox } from '../../../components/common/shared/statelessMethods';
import { StyledSearchButton } from '../SearchForm/SearchForm.styled';
import { StyledResultTableWrapper } from './ResultTable.styled';

const ResultTable = () => {
    const dispatch = useDispatch();
    const accessToken = useSelector((state) => state.auth.accessToken);
    const isAdmin = useSelector(isAdminSelector);
    const searchResults = useSelector((state) => state.admin.searchResults);
    const { t } = useTranslation();

    const [data, setData] = useState([]);

    //check if the user is authorized and if he is admin, fetching data
    useEffect(() => {
        (async function () {
            dispatch(showLoader());

            if (!accessToken) {
                await dispatch(verifyLoggedIn());
            }

            dispatch(hideLoader());
        })();
    }, []);

    useEffect(() => {
        setData(searchResults)
    }, [searchResults]);

    const columns = [
        {
            Header: t('searchPayments.tableHeaders.aptNumber'),
            id: 'aptNumber',
            accessor: 'apartment_details.apartmentNumber',
        },
        {
            Header: t('searchPayments.tableHeaders.createdAt'),
            id: 'createdAt',
            accessor: 'createdAt',
            Cell: row => {
                const dateParsed = BllinkUtils.BllinkTime.parseDate(row.row.original.createdAt);
                return <>{dateParsed}</>
            }
        },
        {
            Header: t('searchPayments.tableHeaders.planDescription'),
            id: 'planDescription',
            Cell: row => {
                const selected = row.row.original.selectedMonths;
                return <>{Array.isArray(selected) && selected.length > 0 ? calcMonthsTextForSelectBox(selected) : '-'}</>
            }
        },
        {
            Header: t('searchPayments.tableHeaders.planStatus'),
            id: 'planStatus',
            Cell: row => {
                const status = constants.PaymentPlanDetailsStatus[row.row.original.status];
                return <>{status ? t(`statuses.${status}`) : ''}</>
            }
        },
        {
            Header: t('searchPayments.tableHeaders.planComment'),
            id: 'planComment',
            accessor: 'comment'
        },
        {
            Header: t('searchPayments.tableHeaders.clientName'),
            id: 'clientName',
            accessor: 'clientName'
        },
        {
            Header: '',
            id: 'plansActions',
            Cell: row => {
                return (
                    <Link to={`${constants.pages.admin.searchPaymentsUrl}/planActions/${row.row.original.PaymentPlanID}`}>
                        <StyledSearchButton>{t('searchPayments.btns.planActions')}</StyledSearchButton>
                    </Link>
                )
            }
        },
    ];

    if (!isAdmin) return <div>{t('searchPayments.noAdminRights')}</div>;

    return (
        <StyledResultTableWrapper>
            <Link to={constants.pages.admin.searchPaymentsUrl}>
                <StyledSearchButton className='marginBottom'>{t('searchPayments.btns.return')}</StyledSearchButton>
            </Link>
            {data.length === 0 ? (
                    <div className='info-text'>{t('searchPayments.nothingFound')}</div>
                ) : (
                    <Table
                        columns={columns}
                        data={data}
                        tableTitle={t('searchPayments.tableTitle')}
                    />
                )
            }
        </StyledResultTableWrapper>
    );
};

export default ResultTable;
